<template>
  <!--手机广告添加  -->
  <div class="mobileAdd">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="图片广告" name="first">
        <div class="add_box">
          <el-form
            :model="modileData"
            label-position="right"
            label-width="200px"
            ref="ruleForm"
            style="width: 90%; margin: 20px auto"
          >
            <el-row>
              <el-col :span="10">
                <el-form-item label="标题" prop="title">
                  <el-input
                    placeholder="请输入内容"
                    v-model="modileData.title"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="链接">
                  <el-input
                    placeholder="请输入内容"
                    v-model="modileData.linkTo"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="起始时间" prop="startDate">
                  <el-date-picker
                    v-model="modileData.startDate"
                    placeholder
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="结束时间" prop="endDate">
                  <el-date-picker
                    v-model="modileData.endDate"
                    placeholder
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="频道" prop="menuId">
                  <el-select
                    placeholder="请选择"
                    v-model="modileData.menuId"
                    clearable
                  >
                    <el-option
                      v-for="item in menuDas"
                      :key="item.id"
                      :label="item.menuName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="是否分享 " prop="menuId">
                  <el-select
                    placeholder="请选择"
                    v-model="modileData.shareFlag"
                    clearable
                  >
                    <el-option
                      v-for="item in homeLun"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item
                  label="app 端图片(650*330)"
                  prop="imgUrl"
                  ref="appImgUrl"
                >
                  <el-upload
                    class="avatar-uploader"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="appImg"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    ref="uptImg"
                  >
                    <img
                      v-if="modileData.imgUrl"
                      :src="modileData.imgUrl"
                      class="avatar"
                    />
                    <i
                      :class="
                        appLoad
                          ? 'el-icon-loading'
                          : 'el-icon-plus avatar-uploader-icon'
                      "
                      style="margintop: 10px; font-size: 50px; marginleft: 70px"
                      v-else
                    ></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item
                  label="pc 端图片(592*400)"
                  prop="pcImgUrl"
                  ref="pcImgUrl"
                >
                  <el-upload
                    class="avatar-uploader"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="pcImg"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    ref="uptImg"
                  >
                    <img
                      v-if="modileData.pcImgUrl"
                      :src="modileData.pcImgUrl"
                      class="avatar"
                    />
                    <!-- <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  style="margin:70px 75px;font-size: 50px;"
                ></i> -->
                    <i
                      :class="
                        pcLoad
                          ? 'el-icon-loading'
                          : 'el-icon-plus avatar-uploader-icon'
                      "
                      style="margintop: 10px; font-size: 50px; marginleft: 70px"
                      v-else
                    ></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="信息流位置 " prop="menuId">
                  <el-select
                    placeholder="请选择"
                    v-model="modileData.location"
                    clearable
                  >
                    <el-option
                      v-for="item in locationItem"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-button
                style="margin-left: 200px"
                type="primary"
                @click="submitAdd('ruleForm')"
                v-if="menuPerm('ad:insert')"
                >保存</el-button
              >
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="视频广告" name="second">
        <div class="add_box">
          <el-form
            :model="modileData"
            label-position="right"
            label-width="200px"
            ref="ruleForm"
            style="width: 90%; margin: 20px auto"
          >
            <el-row>
              <el-col :span="10">
                <el-form-item label="标题" prop="title">
                  <el-input
                    placeholder="请输入内容"
                    v-model="modileData2.title"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item
                  label="上传视频(只支持MP4)"
                  prop="linkTo"
                  ref="linkTo"
                  class="shadow"
                >
                  <el-upload
                    class="avatar-uploader"
                    :action="serverUrl"
                    :headers="header"
                    name="img"
                    :auto-upload="true"
                    :show-file-list="false"
                    :on-success="upSuccess"
                  >
                    <video
                      v-if="modileData2.linkTo"
                      :src="modileData2.linkTo"
                      class="avatar"
                      style="height: 150px"
                    />

                    <i
                      :class="
                        loadUpt
                          ? 'el-icon-loading'
                          : 'el-icon-plus avatar-uploader-icon'
                      "
                      style="margintop: 10px; font-size: 50px"
                      v-else
                    ></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="起始时间" prop="startDate">
                  <el-date-picker
                    v-model="modileData2.startDate"
                    placeholder
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="结束时间" prop="endDate">
                  <el-date-picker
                    v-model="modileData2.endDate"
                    placeholder
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="频道" prop="menuId">
                  <el-select
                    placeholder="请选择"
                    v-model="modileData2.menuId"
                    clearable
                  >
                    <el-option
                      v-for="item in menuDas"
                      :key="item.id"
                      :label="item.menuName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="是否分享 " prop="menuId">
                  <el-select
                    placeholder="请选择"
                    v-model="modileData2.shareFlag"
                    clearable
                  >
                    <el-option
                      v-for="item in homeLun"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="信息流位置 " prop="menuId">
                  <el-select
                    placeholder="请选择"
                    v-model="modileData2.location"
                    clearable
                  >
                    <el-option
                      v-for="item in locationItem"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-button
                style="margin-left: 200px"
                type="primary"
                @click="submitAdd2('ruleForm')"
                v-if="menuPerm('ad:insert')"
                >保存</el-button
              >
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="第三方广告" name="third">
        <div class="add_box">
          <el-form
            :model="modileData"
            label-position="right"
            label-width="200px"
            ref="ruleForm"
            style="width: 90%; margin: 20px auto"
          >
            <el-row>
              <el-col :span="10">
                <el-form-item label="起始时间" prop="startDate">
                  <el-date-picker
                    v-model="modileData3.startDate"
                    placeholder
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="结束时间" prop="endDate">
                  <el-date-picker
                    v-model="modileData3.endDate"
                    placeholder
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="频道" prop="menuId">
                  <el-select
                    placeholder="请选择"
                    v-model="modileData3.menuId"
                    clearable
                  >
                    <el-option
                      v-for="item in menuDas"
                      :key="item.id"
                      :label="item.menuName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="信息流位置 " prop="menuId">
                  <el-select
                    placeholder="请选择"
                    v-model="modileData3.location"
                    clearable
                  >
                    <el-option
                      v-for="item in locationItem"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-button
                style="margin-left: 200px"
                type="primary"
                @click="submitAdd3('ruleForm')"
                v-if="menuPerm('ad:insert')"
                >保存</el-button
              >
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="长图广告" name="four">
        <div class="add_box">
          <el-form
            :model="modileData"
            label-position="right"
            label-width="200px"
            ref="ruleForm"
            style="width: 90%; margin: 20px auto"
          >
            <el-row>
              <el-col :span="10">
                <el-form-item label="标题" prop="title">
                  <el-input
                    placeholder="请输入内容"
                    v-model="modileData.title"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="摘要">
                  <el-input
                    placeholder="请输入摘要"
                    v-model="modileData.zhaiyao"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="起始时间" prop="startDate">
                  <el-date-picker
                    v-model="modileData.startDate"
                    placeholder
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="结束时间" prop="endDate">
                  <el-date-picker
                    v-model="modileData.endDate"
                    placeholder
                    clearable
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="频道" prop="menuId">
                  <el-select
                    placeholder="请选择"
                    v-model="modileData.menuId"
                    clearable
                  >
                    <el-option
                      v-for="item in menuDas"
                      :key="item.id"
                      :label="item.menuName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="是否分享 " prop="menuId">
                  <el-select
                    placeholder="请选择"
                    v-model="modileData.shareFlag"
                    clearable
                  >
                    <el-option
                      v-for="item in homeLun"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="10">
                <el-form-item label="长图" prop="imgUrl" ref="appImgUrl">
                  <el-upload
                    class="avatar-uploader"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="changImg"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    ref="uptImg"
                  >
                    <img
                      v-if="modileData.changtuUrl"
                      :src="modileData.changtuUrl"
                      class="avatar"
                    />
                    <i
                      :class="
                        appLoad
                          ? 'el-icon-loading'
                          : 'el-icon-plus avatar-uploader-icon'
                      "
                      style="margintop: 10px; font-size: 50px; marginleft: 70px"
                      v-else
                    ></i>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="封面图(650*330)" prop="pcImgUrl" ref="pcImgUrl">
                  <el-upload
                    class="avatar-uploader"
                    action="https://jsonplaceholder.typicode.com/posts/"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="fengImg"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    ref="uptImg"
                  >
                    <img
                      v-if="modileData.imgUrl"
                      :src="modileData.imgUrl"
                      class="avatar"
                    />
                    <!-- <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                  style="margin:70px 75px;font-size: 50px;"
                ></i> -->
                    <i
                      :class="
                        pcLoad
                          ? 'el-icon-loading'
                          : 'el-icon-plus avatar-uploader-icon'
                      "
                      style="margintop: 10px; font-size: 50px; marginleft: 70px"
                      v-else
                    ></i>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="信息流位置 " prop="menuId">
                  <el-select
                    placeholder="请选择"
                    v-model="modileData.location"
                    clearable
                  >
                    <el-option
                      v-for="item in locationItem"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-button
                style="margin-left: 200px"
                type="primary"
                @click="submitAdd4('ruleForm')"
                v-if="menuPerm('ad:insert')"
                >保存</el-button
              >
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { baseURL } from "../../api/config";
export default {
  data() {
    var appValiIcon = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.modileData.imgUrl == "") {
        callback(new Error("app专题封面图不能为空"));
      } else {
        callback();
      }
    };
    var pcValiIcons = (rule, value, callback) => {
      // 图片验证
      // alert(this.$refs.imgUrl)
      if (this.modileData.pcImgUrl == "") {
        callback(new Error("pc专题封面图不能为空"));
      } else {
        callback();
      }
    };
    return {
      appLoad: false,
      pcLoad: false,
      loadUpt: false,
      activeName: "first",
      myHeaders: { token: this.$store.state.token },
      serverUrl: baseURL + "/file/uploadFile",
      header: {
        token: localStorage.getItem("key"),
      },
      modileData2: {
        title: "", //标题
        linkTo: "", //广告跳转的链接
        startDate: "", //广告起始时间
        endDate: "", //广告结束时间
        imgUrl: "", //app 端图片的路径
        pcImgUrl: "", //pc 端图片的路径
        menuId: "", //频道的 id
        showPosition: "", //是否页面显示
        location: "",
        shareFlag: "", //是否分享
      },
      modileData3: {
        startDate: "", //广告起始时间
        endDate: "", //广告结束时间
        menuId: "", //频道的 id
        location: "",
      },
      modileData: {
        title: "", //标题
        linkTo: "", //广告跳转的链接
        startDate: "", //广告起始时间
        endDate: "", //广告结束时间
        imgUrl: "", //app 端图片的路径
        pcImgUrl: "", //pc 端图片的路径
        menuId: "", //频道的 id
        showPosition: "", //是否页面显示
        location: "",
        shareFlag: "", //是否分享
        changtuUrl: "",
        zhaiyao: "",
      },
      modileRule: {
        title: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        // linkTo: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        startDate: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        endDate: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        menuId: [{ required: true, message: "内容不能为空", trigger: "blur" }],
        shareFlag: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        showPosition: [
          { required: true, message: "内容不能为空", trigger: "blur" },
        ],
        imgUrl: [{ required: true, validator: appValiIcon, trigger: "blur" }],
        pcImgUrl: [{ required: true, validator: pcValiIcons, trigger: "blur" }],
      },
      appUptImg: [], //app上传图片
      pcUptImg: [], //pc上传图片
      menuDas: [], //频道数据
      //   信息流展示：--下拉框
      messDas: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
      //当前频道轮播:--下拉框
      viewLun: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
      //   是否上首页：--下拉框
      homeIn: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
      //首页轮播--下拉框：
      homeLun: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "不是",
        },
      ],
      locationItem: [
        {
          value: "1",
          label: "第一信息流",
        },
        {
          value: "2",
          label: "第二信息流",
        },
        {
          value: "3",
          label: "第三信息流",
        },
        {
          value: "4",
          label: "第四信息流",
        },
        {
          value: "5",
          label: "第五信息流",
        },
        {
          value: "6",
          label: "第六信息流",
        },
        {
          value: "7",
          label: "第七信息流",
        },
        {
          value: "8",
          label: "第八信息流",
        },
        {
          value: "9",
          label: "第九信息流",
        },
        {
          value: "10",
          label: "第十信息流",
        },
      ],
      type: "",
    };
  },
  methods: {
    handleClick(tab, event) {
      if (tab.name == "first") {
        this.type = 1;
      } else if (tab.name == "second") {
        this.type = 2;
        this.modileData = {};
      } else if (tab.name == "third") {
        this.type = 16;
        this.modileData = {};
        this.modileData2 = {};
      } else if (tab.name == "four") {
        this.type = 1;
        this.modileData = {};
        this.modileData2 = {};
      }
    },
    upSuccessApp(file) {
      this.modileData2.imgUrl = file.entity;
    },
    upSuccessPc(file) {
      this.modileData2.pcImgUrl = file.entity;
    },
    upSuccess(file) {
      this.modileData2.linkTo = file.entity;
    },
    //转base64
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file.raw);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    //上传图片限制
    beforeUpload(file, fileList) {
      return new Promise((resolve) => {
        // 图片压缩
        let reader = new FileReader(),
          img = new Image();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          img.src = e.target.result;
        };

        img.onload = function () {
          let canvas = document.createElement("canvas");
          let context = canvas.getContext("2d");
          let width = "100";
          let height = "100";
          let originWidth = width;
          let originHeight = height;
          canvas.width = originWidth;
          canvas.height = originHeight;

          context.clearRect(0, 0, originWidth, originHeight);
          context.drawImage(img, 0, 0, originWidth, originHeight);

          canvas.toBlob(
            (blob) => {
              let imgFile = new File([blob], file.name, { type: file.type }); // 将blob对象转化为图片文件
              resolve(imgFile);
            },
            file.type,
            0.2
          ); // file压缩的图片类型
        };
      });
    },
    //上传成功：
    handleSuccess(res, file) {
      this.$refs.uptImg.clearValidate();
    },
     fengImg(file) {
      this.appLoad = true;
      this.appUptImg = [];
      this.getBase64(file).then((resBase64) => {
        this.appUptImg.push(resBase64);
        if (this.appUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.appUptImg,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.modileData.imgUrl = res.content[0]; //接口url参数
              this.appLoad = false;
              this.appUptImg = [];
              this.$refs.appImgUrl.clearValidate();
            }
            if (!res.success) {
              this.$message.error(res.message);
            }
            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    changImg(file) {
      this.appLoad = true;
      this.appUptImg = [];
      this.getBase64(file).then((resBase64) => {
        this.appUptImg.push(resBase64);
        if (this.appUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.appUptImg,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.modileData.changtuUrl = res.content[0]; //接口url参数
              this.appLoad = false;
              this.appUptImg = [];
              this.$refs.appImgUrl.clearValidate();
            }
            if (!res.success) {
              this.$message.error(res.message);
            }
            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    //app图片上传：

    appImg(file, fileList) {
      this.appLoad = true;
      this.appUptImg = [];
      this.getBase64(file).then((resBase64) => {
        this.appUptImg.push(resBase64);
        if (this.appUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.appUptImg,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.modileData.imgUrl = res.content[0]; //接口url参数
              this.appLoad = false;
              this.appUptImg = [];
              this.$refs.appImgUrl.clearValidate();
            }
            if (!res.success) {
              this.$message.error(res.message);
            }
            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    //pc图片上传：
    pcImg(file, fileList) {
      this.pcLoad = true;
      this.pcUptImg = [];
      this.getBase64(file).then((resBase64) => {
        this.pcUptImg.push(resBase64);
        if (this.pcUptImg) {
          this.postAxios("/file/uploadBase64", {
            fileList: this.pcUptImg,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success("上传成功");
              this.modileData.pcImgUrl = res.content[0]; //接口url参数
              this.pcLoad = false;
              this.pcUptImg = [];
              this.$refs.pcImgUrl.clearValidate();
            }
            if (!res.success) {
              this.$message.error(res.message);
            }
            if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            }
          });
        }
      });
    },
    addZero(num) {
      return num < 10 ? "0" + num : num;
    },
    formatDateTime(date) {
      const time = new Date(Date.parse(date));
      //   time.setTime(time.setHours(time.getHours() + 8));
      const Y = time.getFullYear() + "-";
      const M = this.addZero(time.getMonth() + 1) + "-";
      const D = this.addZero(time.getDate()) + " ";
      const h = this.addZero(time.getHours()) + ":";
      const m = this.addZero(time.getMinutes()) + ":";
      const s = this.addZero(time.getSeconds());
      // const s = this.addZero(time.getSeconds());
      return Y + M + D + h + m + s;
    },
    //添加保存成功：
    submitAdd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/ad/insert", {
            title: this.modileData.title, //标题
            linkTo: this.modileData.linkTo, //广告跳转的链接
            startDate: this.formatDateTime(this.modileData.startDate), //广告起始时间
            endDate: this.formatDateTime(this.modileData.endDate), //广告结束时间
            imgUrl: this.modileData.imgUrl, //app 端图片的路径
            pcImgUrl: this.modileData.pcImgUrl, //pc 端图片的路径
            menuId: this.modileData.menuId, //频道的 id
            showPosition: this.modileData.showPosition, //是否页面显示
            type: 1,
            location: this.modileData.location,
            shareFlag: this.modileData.shareFlag, //是否分享
          }).then((res) => {
            if (res.success == true) {
              this.$message.success(res.message);
              this.$router.push("/mobileAdver");
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.error("内容不能为空");
          return false;
        }
      });
    },
    //添加保存成功：
    submitAdd2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/ad/insert", {
            title: this.modileData2.title, //标题
            linkTo: this.modileData2.linkTo, //广告跳转的链接
            startDate: this.formatDateTime(this.modileData2.startDate), //广告起始时间
            endDate: this.formatDateTime(this.modileData2.endDate), //广告结束时间
            imgUrl: this.modileData2.imgUrl, //app 端图片的路径
            pcImgUrl: this.modileData2.pcImgUrl, //pc 端图片的路径
            menuId: this.modileData2.menuId, //频道的 id
            showPosition: this.modileData2.showPosition, //是否页面显示
            type: 2,
            location: this.modileData2.location,
            shareFlag: this.modileData2.shareFlag, //是否分享
          }).then((res) => {
            if (res.success == true) {
              this.$message.success(res.message);
              this.$router.push("/mobileAdver");
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.error("内容不能为空");
          return false;
        }
      });
    },
    submitAdd3(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/ad/insert", {
            startDate: this.formatDateTime(this.modileData3.startDate), //广告起始时间
            endDate: this.formatDateTime(this.modileData3.endDate), //广告结束时间
            menuId: this.modileData3.menuId, //频道的 id
            type: 16,
            location: this.modileData3.location,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success(res.message);
              this.$router.push("/mobileAdver");
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.error("内容不能为空");
          return false;
        }
      });
    },
    submitAdd4(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.postAxios("/ad/insert", {
            title: this.modileData.title, //标题
            linkTo: this.modileData.linkTo, //广告跳转的链接
            startDate: this.formatDateTime(this.modileData.startDate), //广告起始时间
            endDate: this.formatDateTime(this.modileData.endDate), //广告结束时间
            imgUrl: this.modileData.imgUrl, //pc 端图片的路径
            menuId: this.modileData.menuId, //频道的 id
            showPosition: this.modileData.showPosition, //是否页面显示
            type: 1,
            location: this.modileData.location,
            shareFlag: this.modileData.shareFlag, //是否分享
            zhaiyao: this.modileData.zhaiyao,
            changtuUrl: this.modileData.changtuUrl,
          }).then((res) => {
            if (res.success == true) {
              this.$message.success(res.message);
              this.$router.push("/mobileAdver");
            } else if (!res.success && res.statusCode == "401") {
              this.$message.error(res.message);
              this.$router.push("/");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.error("内容不能为空");
          return false;
        }
      });
    },
    //频道下拉框数据：
    getPosition() {
      this.getAxios("/menu/list").then((res) => {
        if (res.success == true) {
          this.menuDas = res.content;
        }
        if (!res.success && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        } else if (res.success == false) {
          this.$message.error(res.message);
        }
      });
    },
  },
  created() {
    this.getPosition();
  },
};
</script>
<style scoped lang="less">
.mobileAdd {
  width: 100%;
  height: 100%;
  .add_box {
    width: 95%;
    height: 100%;
    margin: 20px auto;
    /deep/ .avatar-uploader {
      width: 200px;
      height: auto;
      border: 2px dashed #eee;
      img {
        width: 100%;
        height: auto;
      }
    }
    /deep/ .el-button--primary {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      width: 100px;
      margin-top: 10px;
      margin-left: 10px;
    }
  }
}
/deep/ .el-tabs__nav {
  left: 226px;
}
</style>